import React, { useMemo } from 'react';
import { Table } from 'antd';
import { useNavigate } from 'react-router-dom';

import { getColumns } from '../utils/getColumns';
import { OrdersProps } from '../interface/orders.interface';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../interfaces/common.interface';
import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';

export const OrdersTable = (
    props: CommonTableProps<OrdersProps, CommonFiltersProps>
) => {
    const { source, loading, filters, updateFilters, getColumnSearchProps } =
        props;

    const navigate = useNavigate();

    const pagination = useMemo(
        () =>
            dynamicPagination(
                filters,
                updateFilters,
                source?.total,
                'Рассылок'
            ),
        [filters, updateFilters, source?.total]
    );

    const viewOrder = (id: number) => {
        return navigate(`${id}`);
    };

    return (
        <Table
            loading={loading}
            pagination={pagination}
            dataSource={source?.items}
            rowKey={record => record.id}
            columns={getColumns(getColumnSearchProps, updateFilters, viewOrder)}
        />
    );
};
